import { useEffect } from 'react';
import { getFaviconUrls } from 'src/config';

export const useFavicon = () => {
  useEffect(() => {
    const faviconUrls = getFaviconUrls();
    const defaultFavicons = {
      ico: '/favicon.ico',
      png16: '/favicon-16x16.png',
      png32: '/favicon-32x32.png',
      appleTouchIcon: '/apple-touch-icon.png',
    };

    // Function to update favicon with fallback
    const updateFavicon = (selector: string, url: string, fallbackUrl: string) => {
      const link = document.querySelector(selector) as HTMLLinkElement;
      if (link) {
        // Try custom favicon first
        const img = new Image();
        img.onload = () => {
          link.href = url;
        };
        img.onerror = () => {
          link.href = fallbackUrl;
        };
        img.src = url;
      }
    };

    // Update each favicon type
    updateFavicon('link[rel="icon"]:not([type])', faviconUrls.ico, defaultFavicons.ico);
    updateFavicon('link[sizes="16x16"]', faviconUrls.png16, defaultFavicons.png16);
    updateFavicon('link[sizes="32x32"]', faviconUrls.png32, defaultFavicons.png32);
    updateFavicon('link[rel="apple-touch-icon"]', faviconUrls.appleTouchIcon, defaultFavicons.appleTouchIcon);
  }, []);
};
